import { Component, Inject } from '@angular/core';

import { MenuItem } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';

import { AuthService } from '@auth0/auth0-angular';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  items: MenuItem[];
  constructor(private primengConfig: PrimeNGConfig,
    @Inject(DOCUMENT) public document: Document, 
    public auth: AuthService)
  {

  }
  
  ngOnInit() {
    this.items = [
      {
          label: 'Config',
          routerLink: ['config']
      },
      {
          label: 'List View',
          routerLink: ['list']
      },
      {
          label: 'Concordance',
          routerLink: ['concordance']
      },
      {
          label: 'Probes',
          routerLink: ['probes']
      }
      /*{
          label: 'Detail Example',
          routerLink: ['detail', 104581706]
      },*/
    ];
    this.primengConfig.ripple = false;
  }
  title = 'snpviewer-ui';
}
